import { Schema } from "effect";

export const MessageSmsService = Schema.Literal(
  "SMS",
  "MMS",
  "RCS",
  "iMessage",
);
export type MessageSmsService = typeof MessageSmsService.Type;
